const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {},
		buttonContext: 'activity',
		showHead: false,
		showInsertButton: false,
		inline: true
	},

	model: {
		activityYear: 0
	},

	methods: {
		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			if(((resourceFilters || {}).filters || {}).year){
				resourceFilters.year = resourceFilters.filters.year;
				delete resourceFilters.filters.year;
			}

			this.model.activityYear = resourceFilters.year;
		},

		showInsert: function(){
			var self = this;
			var baseActionKey = 'showSelect_address';
			if(self.actions[baseActionKey]){
				return self.performAndStoreAction(
					baseActionKey + '_inEffect',
					self.prepareAction(baseActionKey, undefined, {
						selection: {
							addressType: 'client',
							connectionInclusive: true,
							hasActiveNewsletterEmail: null,
						}
					}),
					true
				);
			}
			return getComponent('artCrmController').showInsert('activity');
		},

		showEdit: function(addressID, activityData){
			if(((this.model.controller || {}).config || {}).usage === 'selection'){
				return this.triggerClosest('onDecision', {
					decisionType: 'activitySelected',
					decisionComponent: this,
					addressID,
					activityData
				});
			}
			return getComponent('artCrmController').showEdit('activity', addressID, utils.simpleMerge(activityData, {
				attributes: {
					activityYear: this.model.activityYear
				}
			}));
		},

		addEntity: function(entity){
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artCrm_entity_controller', function(controller){
					self.model.controller = controller
				});
			}

			self.model.$table = $element.find('table');
		},

		async onDecision($element, options){
			options = options || {};

			switch(options.decisionType){
				case 'addressSelected':
					let modal
					options.decisionComponent.closest('base_modal_modal', c => modal = c)
					if(modal){
					    await modal.hide()
					}
					getComponent('artCrmController').showEdit('activity', options.addressID, utils.merge(options.addressData, {
						attributes: {
							activityYear: this.model.activityYear
						}
					}));
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide();
							break;
					}
					break;

				default:
					break;
			}
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if((
				callerComponent.config.entityContext === 'address' ||
				callerComponent.config.entityContext === 'activity'
			) && this.config.isReady){
				this.refreshData();
			}
		}
	}]
};
